import React, {Component} from 'react'
import { Table } from 'components/UI'
import SelectTeacherModal from 'template/Modals/SelectTeacher'
import Teacher from 'mediators/Teacher';
import updateClassTeacher from 'controllers/class/updateClassTeacher'
import {fetchClassTeacher} from './ducks'
import __R from 'containers/__R';

const CONTROLLER_WIDTH = '150px'


class TeacherTable extends Component {
  constructor(props){
    super(props)
  }

  render(){
    let {tableData, dispatch, settings, params, classDetail} = this.props
    let {classTeacherList} = tableData
    const {cType, cState} = classDetail.detail || {}
    let {classId} = params
    let schoolId = localStorage.getItem('schoolId')

    if(!classTeacherList){
      return ( <div /> )
    }

    const fields = [{
      name: 'stName',
      title: __('Teacher Name', 'teacher'),
    }]

    return(
      <Table
        data={classTeacherList}
        fields={fields}
        className='teacher-table'
        settingThTitle={__('Settings', 'class', null, true)}
        settingWidth={CONTROLLER_WIDTH}
        settings={settings}
        useMultiSelection={false}
        oneSettingPerRow={false}
        dropdownGuideWidth={160}
        dropdownGuideHeight={228}
        usePagination={false}
        hasTopUtilSection={true}
        topUtilSection={
          <div>
            <div className='lesson-student-table'>
              <span className='title'>{__('Teachers: ', 'studentTable')}</span>
              <span  className='student-count'>{classTeacherList.length}</span>
              <button className='btn btn-primary' style={{visibility: 'hidden'}}>TEST</button>
              <__R can={cType == 0? 'assign_teacher_to_class': 'assign_teacher_to_private_class'} by="disable">
                <button className='pull-right btn btn-primary' disabled={cState == 0 ? true : false} onClick={() => {
                  SelectTeacherModal({
                    schoolId,
                    selectMultiple: true,
                    selected: classTeacherList.map((s) => {
                      return new Teacher(s)
                    })
                  })
                  .then((res) => {
                    let arr = [];
                    res.map((teacher) => {
                      arr.push({teacher_id: teacher.id, class_or_not: true})
                    })
                    updateClassTeacher(classId, {changes: arr})
                    .then((res) => {
                      dispatch(fetchClassTeacher(classId))
                    })
                  })
                  }}>
                  {__('New Teacher', 'studentTable')}
                </button>
              </__R>
            </div>
          </div>
        }
      />
    )
  }
}


export default (TeacherTable)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/TeacherTable/index.js